import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=a4db94fa&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=a4db94fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4db94fa",
  null
  
)

export default component.exports